module.exports = __webpack_public_path__ + "static/media/product-user.c59a6ae9.svg";